import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { DataService } from './data.service';

@Injectable()
export class AuthGuard implements CanActivate {
  roles: any;
  constructor(
    private authService: AuthenticationService,
    private dataService: DataService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.roles = JSON.parse(window.localStorage.getItem('userRoles'));
    const allowedRoles = route.data.allowedRoles;
    let roleMatched;
    for(let i = 0; i < this.roles.length; i++) {
      if(this.roles[i] === allowedRoles[0]) {
        roleMatched = true;
      }
    }
    if(roleMatched) {
      return true;
    } else {
      window.localStorage.clear();
      this.router.navigate(['']);
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/auth.guard.ts